// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__w0_d2","largestCol":"styles_largestCol__26CfO","smallestCol":"styles_smallestCol__1giLq"};